import React from "react";
import { Stack, Button } from "@mui/material";
import PayrollsPopup from "../../../../../Components/PayrollPopup";

const EmployeePayrollMappingActionButtons = ({
  onClose,
  handleUpdate,
  handleDelete,
  handleCancel,
  updatingPayroll = false,
  rateChangeConfirm = { open: false, onYes: null, onNo: null },
  setRateChangeConfirm,
}) => {
  return (
    <>
      <Stack direction="row" spacing={1}>
        {onClose && (
          <Button
            sx={{ px: 3, py: 0.5, fontSize: "0.7rem" }}
            onClick={() => handleUpdate(false)}
            disabled={updatingPayroll}
          >
            <span>
              {" "}
              Update & <u>N</u>ext
            </span>
          </Button>
        )}
        <Button
          sx={{ px: 3, py: 0.5, fontSize: "0.7rem" }}
          onClick={() => handleUpdate(true)}
          disabled={updatingPayroll}
        >
          U<u>p</u>date & Close
        </Button>
        <Button
          sx={{
            px: 3,
            py: 0.5,
            fontSize: "0.7rem",
            backgroundColor: "#d32f2f",
            color: "white",
            "&:hover": { backgroundColor: "#b71c1c" },
          }}
          onClick={handleDelete}
          disabled={updatingPayroll}
        >
          <u>D</u>elete
        </Button>
        <Button
          sx={{ px: 3, py: 0.5, fontSize: "0.7rem" }}
          onClick={handleCancel}
          disabled={updatingPayroll}
        >
          <u>C</u>ancel
        </Button>
      </Stack>

      {/* Rate Change Confirmation Modal */}
      {rateChangeConfirm?.open && (
        <PayrollsPopup
          open={rateChangeConfirm.open}
          popupType="cancel"
          message="Do you want to update in employee master?"
          onConfirm={() => {
            const onYes = rateChangeConfirm.onYes;
            setRateChangeConfirm({ open: false, onYes: null, onNo: null });
            if (onYes) onYes();
          }}
          onCancel={() => {
            const onNo = rateChangeConfirm.onNo;
            setRateChangeConfirm({ open: false, onYes: null, onNo: null });
            if (onNo) onNo();
          }}
          onDismiss={() => {
            setRateChangeConfirm({ open: false, onYes: null, onNo: null });
          }}
          onClose={() => {
            setRateChangeConfirm({ open: false, onYes: null, onNo: null });
          }}
        />
      )}
    </>
  );
};

export default React.memo(EmployeePayrollMappingActionButtons);
